import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55bebe45"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "statusUpdateModal",
  tabindex: "-1",
  "aria-labelledby": "statusUpdateModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-center w-100" }, /*#__PURE__*/_toDisplayString('追加項目の更新'), -1))
const _hoisted_5 = { class: "content mx-auto" }
const _hoisted_6 = { class: "text-center my-4 fs-7" }
const _hoisted_7 = { class: "modal-footer row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_8 = { class: "d-flex col-lg-12 justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  serverError: Boolean,
},
  emits: ['onCloseModal', 'onFetchDataDetail'],
  setup(__props, { emit }) {

const props = __props




const onFetchData = () => {
  if (!props.serverError) {
    emit('onFetchDataDetail')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header" }, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: onFetchData
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.serverError ? _unref(translate)('CG40updateFailed') : _unref(translate)('updateComplete')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold',
              onClick: onFetchData
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})